// extracted by mini-css-extract-plugin
export default {"cross":"style_cross__y-gQl","container":"style_container__tPl7O","title":"style_title__k-wde","subtitle":"style_subtitle__VC6Sb","button":"style_button__h-Cfd"};